import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import 'react-datepicker/dist/react-datepicker.css';

import * as cmAPI_Action from 'actions/commons';

import { Dropdown, Form, Input, Label, Icon, Button } from 'semantic-ui-react';

class DatePickerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment('2019'),
      endDate: moment()
    };
  }

  componentWillMount() {
    const { startDate, endDate } = this.state;
    this.handleChange(startDate, 'sDate');
    this.handleChange(endDate, 'eDate');
  }

  handleChange = (date, type) => {
    if (type === 'sDate') {
      this.setState({ startDate: date });
    } else if (type === 'eDate') {
      this.setState({ endDate: date });
    }

    const { commonFn } = this.props;
    commonFn.changeDate({
      type: 'date',
      name: type,
      value: date.format('LLL')
    });
  };

  render() {
    return (
      <Form.Group widths="equal" className="date-form">
        <Input labelPosition="right" type="text">
          <Label basic>
            <Icon disabled name="calendar" />
          </Label>
          <DatePicker
            className="startDate"
            selected={this.state.startDate}
            onChange={(e) => this.handleChange(e, 'sDate')}
            dateFormat="YYYY"
            placeholderText="YYYY"
          />
        </Input>
        <Icon name="minus" className="datepicker-bar" />
        <Input labelPosition="right" type="text">
          <Label basic>
            <Icon disabled name="calendar" />
          </Label>
          <DatePicker
            className="endDate"
            selected={this.state.endDate}
            onChange={(e) => this.handleChange(e, 'eDate')}
            dateFormat="YYYY"
            placeholderText="YYYY"
          />
        </Input>
      </Form.Group>
    );
  }
}

DatePickerForm = connect(
  (state) => ({
    date: state.commons.date
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeDate: cmAPI_Action.ReduxDataSet
      },
      dispatch
    )
  })
)(DatePickerForm);

export default DatePickerForm;
